/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  // Preview a variant's image when hovering its size/price add-to-cart button
  // in the product grid, reverting to the default image on mouseout.
  (function() {
    var buttonSelector = '.product__grid__size-price-button[data-preview-media-id]';

    function getActiveVariantElement(button) {
      var card = button.closest('product-grid-item');
      return card ? card.querySelector('product-grid-item-variant:not([hidden])') : null;
    }

    function previewMedia(button, mediaId) {
      var variantElement = getActiveVariantElement(button);
      if (!variantElement || !mediaId) return;
      variantElement.dispatchEvent(new CustomEvent('theme:swatch:change', {
        detail: { id: mediaId, stopSlideAnimation: true }
      }));
    }

    document.addEventListener('mouseover', function(event) {
      var button = event.target.closest(buttonSelector);
      if (!button) return;
      previewMedia(button, button.getAttribute('data-preview-media-id'));
    });

    document.addEventListener('mouseout', function(event) {
      var button = event.target.closest(buttonSelector);
      if (!button || button.contains(event.relatedTarget)) return;
      var variantElement = getActiveVariantElement(button);
      if (!variantElement) return;
      var defaultImage = variantElement.querySelector('[data-grid-image="0"]');
      var defaultMediaId = defaultImage ? defaultImage.getAttribute('data-grid-image-target') : null;
      previewMedia(button, defaultMediaId);
    });
  })();
  // On the home page, collection pages and content pages, open the cart drawer after
  // an add to cart instead of showing the "added to cart" popdown. The drawer is opened
  // once the theme has fetched the updated cart, so it shows the new item.
  (function() {
    var templates = ['template-index', 'template-collection', 'template-page'];
    var classes = document.body.classList;
    if (!templates.some(function(name) { return classes.contains(name); })) return;

    window.addEventListener('theme:cart:popdown', function(event) {
      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (!drawer) return;
      // Capture phase on window runs before the theme's popdown listener on document
      event.stopPropagation();
      document.addEventListener('theme:cart:change', function() {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
      }, { once: true });
    }, true);
  })();

  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();
